import * as SportType from 'constants/SportType';

export const FORWARD = 1;
export const BACKWARD = 2;

export const DirectionMap = {
    [SportType.BASKETBALL]: BACKWARD,
    [SportType.ICE_HOCKEY]: BACKWARD
};

export function getDirection(sportId) {
    return DirectionMap[sportId] || FORWARD;
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/direction.js